<template>
    <div :class="{online: isOnline}"><slot></slot></div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters('voice', [
        'isOnline',
      ]),
    },
  }
</script>
